<script lang="ts">
	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { onMount } from 'svelte';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/UpHomeServicePageTeaserTracking.ts';
	import TrackingService from '../../../services/tracking/TrackingService.ts';

	let trackingService: TrackingService;

	let { teaserContent }: {
		teaserContent: TeaserContent
	} = $props();


	const onTeaserClicked = () => {
		trackClick(trackingService, {
			up_Promo: 'ToUpHome',
			up_TeaserType: TeaserType.TO_UP_HOME,
			up_TeaserSize: 'MediaObject100'
		});
	};


	const onTeaserSeen = () => {
		trackSeen(trackingService, {
			up_Promo: 'seen',
			up_TeaserType: TeaserType.TO_UP_HOME,
			up_TeaserSize: 'MediaObject100'
		});
	};

	onMount(() => {
		trackingService = new TrackingService();
		trackView(trackingService, {
			up_Promo: 'view',
			up_TeaserType: TeaserType.TO_UP_HOME,
			up_TeaserSize: 'MediaObject100'
		});
	});
</script>


<div class="oc-mt-100 oc-mb-150 oc-mx-100"
	data-testid="to-up-home"
	onclick={onTeaserClicked}
	use:onViewport
	onenterViewport={onTeaserSeen}
>
	<a class="to-home-link" href="/myaccount/up" id="to-home-link">
		<oc-media-object-card-v1
			as-button=""
			inverted="true"
			data-testid="to-home-teaser-card"
			elevation-level="canvas"
			icon="otto-up"
			size="100"
			variant="icon"
            oc-aria-label="Anmeldung zum Vorteilsprogramm"
		>
			<div aria-hidden="true" id="headline" slot="headline">{teaserContent?.heading}</div>
			<div aria-hidden="true" id="subline" slot="subline">{teaserContent?.subheading}</div>
		</oc-media-object-card-v1>
	</a>
</div>

<style lang="scss">
  .to-home-link {
    all: unset;
  }
</style>
